var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.95,25.95l14.45-14.45-2.15-2.15-12.3,12.3-5.95-5.95-2.15,2.15,8.1,8.1Zm-11.95,10.05c-.8,0-1.5-.3-2.1-.9s-.9-1.3-.9-2.1V3c0-.8.3-1.5.9-2.1s1.3-.9,2.1-.9h30c.8,0,1.5.3,2.1.9s.9,1.3.9,2.1v30c0,.8-.3,1.5-.9,2.1s-1.3.9-2.1.9H3Zm0-3h30V3H3v30ZM3,3v30V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.27,37.88c-.62.95-1.7,1.58-2.92,1.58H8.65c-1.22,0-2.3-.63-2.92-1.58h-3.11v.63c0,1.93,1.56,3.49,3.49,3.49h23.77c1.93,0,3.49-1.56,3.49-3.49v-.63h-3.11Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/selectAll.107599802bee62360b0cdb9bf7418abd.svg";
export { ForwardRef as ReactComponent };